/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Showcontacttab2Inputs */

const en_entity_showcontacttab2 = /** @type {(inputs: Entity_Showcontacttab2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Contact Tab`)
};

const de_entity_showcontacttab2 = /** @type {(inputs: Entity_Showcontacttab2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt-Tab anzeigen`)
};

/**
* | output |
* | --- |
* | "Show Contact Tab" |
*
* @param {Entity_Showcontacttab2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_showcontacttab2 = /** @type {((inputs?: Entity_Showcontacttab2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Showcontacttab2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_showcontacttab2(inputs)
	return de_entity_showcontacttab2(inputs)
});
export { entity_showcontacttab2 as "entity_showContactTab" }